// extracted by css-extract-rspack-plugin
export default {"tabButton":"jlR5y","createTabButton":"_Dn1O"};